enum SocialMediaEnum {
  Facebook = 'facebook',
  Instagram = 'instagram',
  YouTube = 'youtube',
  TikTok = 'tiktok',
}

enum ContributorTypeEnum {
  Author = 'Author',
  MedicalReviewer = 'MedicalReviewer',
}

enum IndexTypeEnum {
  articles = 'articles',
  reviews = 'reviews',
  authors = 'authors',
  tags = 'tags',
}

enum ContentType {
  article = 'article',
  review = 'review',
}

export {
  SocialMediaEnum, ContributorTypeEnum, IndexTypeEnum, ContentType,
};
